import { useTranslation } from "react-i18next";

/** Bilingual text; at least one language is expected, the other is a fallback. */
export interface Text {
  ar?: string | null;
  en?: string | null;
}

/** Content-level bilingual text (from specs, fixtures, services) in the active language. */
export function BilingualText({ text, showOther = false }: { text: Text | null | undefined; showOther?: boolean }) {
  const { i18n } = useTranslation();
  if (!text) return null;
  const lang = i18n.language === "en" ? "en" : "ar";
  const other = lang === "ar" ? "en" : "ar";
  const shown = text[lang] ? lang : other;
  return (
    <>
      <span lang={shown} dir="auto">{text[shown]}</span>
      {showOther && text[lang] && text[other] ? (
        <span lang={other} dir={other === "ar" ? "rtl" : "ltr"} style={{ display: "block", fontSize: 12, opacity: 0.85 }}>
          {text[other]}
        </span>
      ) : null}
    </>
  );
}

export function pickText(text: Text | null | undefined, lang: string): string {
  if (!text) return "";
  return (lang === "en" ? text.en || text.ar : text.ar || text.en) ?? "";
}
